<template>
  <div class="classification">
    <div class="header">
      <el-form
        ref="formTool"
        :model="formTool"
        :inline="true"
        style="text-align: left"
      >
        <el-form-item prop="name" label="">
          <el-input
            style="width: 150px"
            v-model="formTool.csoShopName"
            placeholder="搜素CSO公司名称"
            clearable
            size="small"
          />
        </el-form-item>
        <el-form-item prop="name" label="">
          <el-input
            style="width: 176px"
            v-model="formTool.name"
            placeholder="搜索业务员名称"
            clearable
            size="small"
          />
        </el-form-item>
        <!-- 筛选业务员类型 type	业务员类型 0 内部业务员 1 第三方业务员-->
        <el-form-item prop="type" label="">
          <el-select
            style="width: 220px"
            size="small"
            placeholder="筛选业务员类型"
            clearable
            v-model="formTool.type"
          >
            <el-option :label="'内部业务员'" value="0"></el-option>
            <el-option :label="'第三方业务员'" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="userTel" label="">
          <el-input
            style="width: 150px"
            v-model="formTool.userTel"
            placeholder="搜索业务员账号"
            clearable
            size="small"
          />
        </el-form-item>
        <!-- auditStatus	审核状态 0待审核 1审核通过 2审核不通过 -->
        <el-form-item prop="auditStatus" label="">
          <el-select
            style="width: 220px"
            size="small"
            placeholder="筛选审核状态"
            clearable
            v-model="formTool.auditStatus"
          >
            <el-option
              v-for="item in auditStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" @click="getList(1)"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="center" style="position: relative">
      <MyTable
        :index="false"
        :table-data="tableData"
        :page="page"
        :table-option.sync="tableOption"
        @page-change="getList"
      >
        <template slot="type" slot-scope="scope">
          <span>{{ typesMap[scope.row.type] }}</span>
        </template>
        <template slot="auditStatus" slot-scope="scope">
          <span>{{ auditStatusMap[scope.row.auditStatus] }}</span>
        </template>
        <template slot="operate" slot-scope="scope">
          <div class="table-op-col">
            <el-link
              type="primary"
              :underline="false"
              size="small"
              @click="openOpDetail(false, scope.row)"
              >查看</el-link
            >
            <el-link
              v-if="scope.row.auditStatus === 0"
              type="primary"
              :underline="false"
              size="small"
              @click="openOpDetail(true, scope.row)"
              >审核</el-link
            >
          </div>
        </template>
      </MyTable>
    </div>
    <SalesmanDetail ref="opDetailRef" @refresh="handleRefresh" />
  </div>
</template>

<script>
import MyTable from "@/components/myTable";
import Tabs from "@/components/Tabs";
import SalesmanDetail from "./components/salesman-detail.vue";
import { getCsoMemberPage } from "@/api/compliance/checkSalesman";
import dayjs from "dayjs";
import { contractTargetTaskDetail } from "@/api/compliance/task";
export default {
  components: {
    MyTable,
    Tabs,
    SalesmanDetail,
  },
  data() {
    return {
      typesMap: { 0: "内部业务员", 1: "第三方业务员" },
      auditStatusMap: { 0: "待审核", 1: "审核通过", 2: "审核不通过" },
      auditStatusList: [
        { value: 0, label: "待审核" },
        { value: 1, label: "审核通过" },
        { value: 2, label: "审核不通过" },
      ],
      formTool: {
        csoShopName: "",
        name: "",
        userTel: "",
        type: "",
        auditStatus: "",
      },
      tableData: [],
      tableOption: [
        { label: "CSO公司名称", prop: "csoShopName" },
        { label: "业务员名称", prop: "name" },
        { label: "业务员账号", prop: "userTel" },
        { label: "类型", prop: "type", slot: true, width: "120px" },
        { label: "审核状态", prop: "auditStatus", slot: true, width: "120px" },
        { label: "提交时间", prop: "subTime" },
        { label: "审核人", prop: "auditBy" },
        { label: "审核时间", prop: "auditTime" },
        { label: "操作", prop: "operate", slot: true, width: "120px" },
      ],
      page: { total: 10, current: 1, size: 10 },
    };
  },
  created() {
    this.getList(1);
  },
  methods: {
    openOpDetail(action = false, row = null) {
      this.$refs.opDetailRef.open({ action, row });
    },
    handleConfirmCheck(params) {
      this.doAudit(params.type, params.reason);
    },
    doAudit(type, reason = "", cb) {
      let status = "";

      status = type === 1 ? "PASS" : "NOT_PASS";
      const data = {
        idList: idList,
        status: status,
        rejectContent: reason,
      };
      //   contractDoTaskPlatformAudit(data).then((res) => {
      //     if (res) {
      //       this.handleRefresh();
      //     }
      //   });
    },
    openChildTaskDetail({ action, id }) {},
    getList(num) {
      if (num) {
        this.page.current = num;
      }
      const { current, size } = this.page;
      let params = {
        current,
        size,
        ...this.formTool,
      };
      this.listLoading = true;
      getCsoMemberPage(params)
        .then((res) => {
          this.tableData = res.records;
          this.page.total = res.total;
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    handleRefresh() {
      this.getList(1);
    },
    handleReset() {
      for (let key in this.formTool) {
        this.formTool[key] = "";
      }
      this.getList(1);
    },
    handleBack() {
      this.$router.back();
    },
    getTaskDetail() {
      contractTargetTaskDetail(this.taskId).then((data) => {
        if (data) {
          this.task = data;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.classification {
  padding: 0px;
  height: calc(100%);
  display: flex;
  flex-direction: column;

  .header {
    height: auto;
    // height: 56px;
    line-height: 32px;
    display: flex;
    flex-wrap: wrap;
    // align-items: center;
    justify-content: space-between;
    padding: 16px 24px 16px 24px !important;
    border-bottom: 1px solid #f5f5f5;

    .font {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      text-align: left;
      color: #262626;
    }

    .el-form-item {
      margin: 0px 0px 0px 8px !important;
    }
  }

  background: white;

  .center {
    margin-top: 16px;
    padding: 0 24px;
    // height: calc(100% - 131px);
    height: 0;
    flex: 1;

    ::v-deep {
      .zt__table {
        height: calc(100% - 60px);
      }
    }

    .shangjia {
      position: absolute;
      z-index: 2;
      bottom: -45px;
    }
  }

  .btn-warp {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    .el-link {
      // margin: 5px;
    }
  }

  .table-op-col {
    display: flex;
    .el-link {
      & + .el-link {
        margin-left: 8px;
      }
    }
  }
}
</style>
